import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es6.array.map.js";
import QTree from 'quasar/src/components/tree/QTree.js';;
export default (function (_ref) {
  var app = _ref.app,
      router = _ref.router,
      store = _ref.store,
      Vue = _ref.Vue;
  Vue.component('tree', {
    mixins: [QTree],
    props: {
      tickSubStrategy: {
        type: String,
        default: 'none',
        validator: function validator(v) {
          return ['leaf'].includes(v);
        }
      }
    },
    computed: {
      meta: function meta() {
        var _this = this;

        var meta = {};

        var travel = function travel(node, parent) {
          var tickStrategy = node.tickStrategy || (parent ? parent.tickStrategy : _this.tickStrategy);
          var key = node[_this.nodeKey],
              isParent = node.children && node.children.length > 0,
              isLeaf = isParent !== true,
              selectable = node.disabled !== true && _this.hasSelection === true && node.selectable !== false,
              expandable = node.expandable !== false,
              hasTicking = tickStrategy !== 'none',
              strictTicking = tickStrategy === 'strict',
              leafFilteredTicking = tickStrategy === 'leaf-filtered',
              leafTicking = tickStrategy === 'leaf' || tickStrategy === 'leaf-filtered';
          var tickable = node.disabled !== true && node.tickable !== false;

          if (leafTicking === true && tickable === true && parent && parent.tickable !== true || _this.tickSubStrategy === 'leaf' && parent && parent.ticked === true) {
            tickable = false;
          }

          var lazy = node.lazy;

          if (lazy && _this.lazy[key]) {
            lazy = _this.lazy[key];
          }

          var m = {
            key: key,
            parent: parent,
            isParent: isParent,
            isLeaf: isLeaf,
            lazy: lazy,
            disabled: node.disabled,
            link: node.disabled !== true && (selectable === true || expandable === true && (isParent === true || lazy === true)),
            children: [],
            matchesFilter: _this.filter ? _this.filterMethod(node, _this.filter) : true,
            selected: key === _this.selected && selectable === true,
            selectable: selectable,
            expanded: isParent === true ? _this.innerExpanded.includes(key) : false,
            expandable: expandable,
            noTick: node.noTick === true || strictTicking !== true && lazy && lazy !== 'loaded',
            tickable: tickable,
            tickStrategy: tickStrategy,
            hasTicking: hasTicking,
            strictTicking: strictTicking,
            leafFilteredTicking: leafFilteredTicking,
            leafTicking: leafTicking,
            ticked: strictTicking === true ? _this.innerTicked.includes(key) : isLeaf === true ? _this.innerTicked.includes(key) : false
          };
          meta[key] = m;

          if (isParent === true) {
            m.children = node.children.map(function (n) {
              return travel(n, m);
            });

            if (_this.filter) {
              if (m.matchesFilter !== true) {
                m.matchesFilter = m.children.some(function (n) {
                  return n.matchesFilter;
                });
              } else if (m.noTick !== true && m.disabled !== true && m.tickable === true && leafFilteredTicking === true && m.children.every(function (n) {
                return n.matchesFilter !== true || n.noTick === true || n.tickable !== true;
              }) === true) {
                m.tickable = false;
              }
            }

            if (m.matchesFilter === true) {
              if (m.noTick !== true && strictTicking !== true && m.children.every(function (n) {
                return n.noTick;
              }) === true) {
                m.noTick = true;
              }

              if (hasTicking) {
                m.indeterminate = m.children.some(function (node) {
                  return node.indeterminate === true;
                });

                if (m.indeterminate !== true) {
                  var sel = m.children.reduce(function (acc, meta) {
                    return meta.ticked === true ? acc + 1 : acc;
                  }, 0);

                  if (sel === m.children.length && m.ticked === true) {
                    m.indeterminate = false;
                  } else if (sel > 0) {
                    m.indeterminate = true;
                  }
                }

                if (m.indeterminate === true) {
                  m.indeterminateNextState = m.children.every(function (meta) {
                    return meta.tickable !== true || meta.ticked !== true;
                  });
                }
              }
            }
          }

          return m;
        };

        this.nodes.forEach(function (node) {
          return travel(node, null);
        });
        return meta;
      }
    },
    methods: {
      __onTickedClick: function __onTickedClick(meta, state) {
        if (meta.indeterminate === true) {
          state = meta.indeterminateNextState;
        }

        if (meta.strictTicking) {
          var keys = [];

          if (this.tickSubStrategy === 'leaf') {
            var travel = function travel(meta) {
              if (meta.isParent) {
                keys.push(meta.key);
                meta.children.forEach(travel);
              } else if (meta.noTick !== true && meta.tickable === true && (meta.leafFilteredTicking !== true || meta.matchesFilter === true)) {
                keys.push(meta.key);
              }
            };

            travel(meta);
          } else {
            keys.push(meta.key);
          }

          this.setTicked(keys, state);
        } else if (meta.leafTicking) {
          var _keys = [];

          var _travel = function _travel(meta) {
            if (meta.isParent) {
              if (state !== true && meta.noTick !== true && meta.tickable === true) {
                _keys.push(meta.key);
              }

              if (meta.leafTicking === true) {
                meta.children.forEach(_travel);
              }
            } else if (meta.noTick !== true && meta.tickable === true && (meta.leafFilteredTicking !== true || meta.matchesFilter === true)) {
              _keys.push(meta.key);
            }
          };

          _travel(meta);

          this.setTicked(_keys, state);
        }
      }
    }
  });
});